import React from 'react';

const styles = {
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
  },
  card: {
    background: 'var(--color-surface)',
    borderRadius: 'var(--radius)',
    boxShadow: 'var(--shadow)',
    padding: '2.5rem',
    width: '100%',
    maxWidth: '480px',
    textAlign: 'center',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: '600',
    marginBottom: '1.5rem',
  },
  description: {
    color: 'var(--color-text-muted)',
    lineHeight: '1.6',
  },
};

export default function Layout({ title, description, children }) {
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        {title && <h1 style={styles.title}>{title}</h1>}
        {description && <p style={styles.description}>{description}</p>}
        {children}
      </div>
    </div>
  );
}
